import React from 'react'

import { useTranslation } from 'react-i18next'

import AlertCard from '@components/myScores/MessagesView/AlertCard'
import { formatDate } from '@utils/formatters/date.formatter'
import { formatPriceInCents } from '@utils/formatters/number.formatter'

import type AccountAlert from '@models/AccountAlert'

interface Props {
  alert: AccountAlert
}

const RefundFailureAccountAlert: React.FC<Props> = ({ alert }) => {
  const { t } = useTranslation()
  return (
    <AlertCard alert={alert}>
      <p className="text-lg mb-2.5">{t('content.incompleteRefund')}</p>
      <p className="mb-2.5">
        {t('content.incompleteRefundAmount', {
          amount: formatPriceInCents(alert.amount ?? 0, { showDouble0ForCents: true }),
          date: formatDate(alert.date),
        })}
      </p>
      <p>{t('content.contactSupport')}</p>
    </AlertCard>
  )
}

export default RefundFailureAccountAlert
